export default __webpack_public_path__ + "static/media/outcomes-friction-animation.e9397081.gif";